import { Card as BaseCard } from "antd";
import styled, { css } from "styled-components";

import color from "../_style/color";

const variants = {
  "profile-config": css`
    .ant-card-head-title {
      display: flex;
      align-items: center;
      font-size: 18px;
      font-weight: 400;
      color: ${color.primary};
    }

    .ant-card-extra {
      font-size: 18px;
      text-align: right;
    }
  `,
};

const Card = styled(BaseCard).attrs((props) => ({
  variant: props.variant || false,
  headerBackground: props.headerBackground,
  width: props.width || "100%",
  bodyPadding: props.bodyPadding || "20px",
  headPadding: props.headPadding || "0 20px",
  radius: props.radius || "2px",
}))`
  background: ${color.light};
  border: 1px solid ${color.gainsboro};
  border-radius: ${({ radius }) => radius};
  flex-direction: column;
  width: ${({ width }) => width};

  .ant-card-head {
    padding: ${({ headPadding }) => headPadding};
    ${({ headerBackground }) =>
      headerBackground &&
      css`
        background-color: ${headerBackground};
      `}
  }

  .ant-card-head-title {
    display: flex;
    align-items: center;
  }

  .ant-card-body {
    padding: ${({ bodyPadding }) => bodyPadding};
  }

  ${({ variant }) => variant && variants[variant]};
`;

export default Card;
